import React, {FC} from 'react'
import * as styles from './ratingStyle.module.css'

interface StarPropTypes {
    filledStars: number
    remainder: number
    siteId: string
}

const Stars: FC<StarPropTypes> = ({filledStars, remainder, siteId}) => {
    const starFullColor = siteId === 'HSASTORE' ? '#4FCCB1' : '#FFB19A'

    const starPartialStyle = {
        position: 'absolute' as const,
        top: '0',
        left: '0',
        overflow: 'hidden' as const,
        whiteSpace: 'nowrap' as const,
        color: starFullColor
    }

    const renderStar = (index: number) => {
        const isFilled = index < filledStars
        const isPartial = index === filledStars && remainder > 0

        return (
            <span
                key={index}
                className={styles.star}
                style={{color: isFilled ? starFullColor : ''}}
            >
                ★
                {isPartial && (
                    <span style={{...starPartialStyle, width: `${remainder * 80}%`}}>★</span>
                )}
            </span>
        )
    }

    return <>{Array.from({length: 5}, (_, index) => renderStar(index))}</>
}

export default Stars
